require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button")) : factory(root["./utils"], root["./svgicon"], root["./button"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__15__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[4],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(147);


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _BackButton = _interopRequireDefault(__webpack_require__(148));

exports["default"] = _BackButton["default"];
exports.BackButton = _BackButton["default"];

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _button = _interopRequireDefault(__webpack_require__(15));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _arrowLeft_ = _interopRequireDefault(__webpack_require__(58));

var _utils = __webpack_require__(4);

var _backbutton = _interopRequireDefault(__webpack_require__(149));

var _StringResource = _interopRequireDefault(__webpack_require__(151));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var backButtonClassName = _backbutton["default"].backButtonClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

function getString(value) {
  return _StringResource["default"].get(value);
}

var BackButton = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(BackButton, _Component);

  function BackButton() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      _this._button = node;
    });
    return _this;
  }

  var _proto = BackButton.prototype;

  _proto.focus = function focus() {
    this._button && this._button.focus();
  };

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        buttonType = _this$props.buttonType,
        className = _this$props.className,
        style = _this$props.style,
        getLocaleString = _this$props.getLocaleString,
        label = _this$props.label,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["buttonType", "className", "style", "getLocaleString", "label"]);

    var dir = _utils.Bidi.resolveDir(this.props.label || '', this.props.dir);

    var classNames = (0, _utils.classnames)(backButtonClassName, (_cx = {}, _cx["" + buttonType] = buttonType, _cx));

    var icon = /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
      iconId: _arrowLeft_["default"].id,
      bidi: true
    });

    var buttonPassthroughProps = getInheritedProps(others, _button["default"]);

    var _label = label || getLocaleString('back');

    var otherProps = !!label ? {
      children: label
    } : {
      hasIconOnly: true,
      iconDescription: _label
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classNames + " " + className,
      dir: dir,
      style: style
    }, /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
      "aria-label": _label
    }, sanitize(others, BackButton), buttonPassthroughProps, otherProps, {
      kind: "ghost",
      size: "small",
      renderIcon: function renderIcon(props) {
        return /*#__PURE__*/_react["default"].createElement(_svgicon["default"], (0, _extends2["default"])({
          icon: _arrowLeft_["default"]
        }, props));
      },
      ref: this._ref
    })));
  };

  return BackButton;
}(_react.Component);

exports["default"] = BackButton;
(0, _defineProperty2["default"])(BackButton, "propTypes", (0, _extends2["default"])({}, _button["default"].propTypes, {
  buttonType: _propTypes["default"].oneOf(['standard', 'label', 'nav_pane']),
  dir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  label: _propTypes["default"].string,
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  pageTextDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  numShape: _propTypes["default"].bool,
  pageNumShape: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  getLocaleString: _propTypes["default"].func
}));
(0, _defineProperty2["default"])(BackButton, "defaultProps", {
  getLocaleString: getString,
  buttonType: 'standard',
  className: '',
  style: {}
});

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(150);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-backbutton{display:inline-block;position:relative}.ba-backbutton .ba-common-button.is-variant_frameless{background-color:transparent;padding:0}.ba-backbutton .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left{padding:0}.ba-backbutton .ba-common-button.is-variant_frameless.is-hover:not(.is-disabled),.ba-backbutton .ba-common-button.is-variant_frameless:hover:not(.is-disabled):not(.is-tap){background-color:transparent}.ba-backbutton.is-standard .ba-common-button{height:40px;font-size:1.5rem;font-weight:600}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__layout{overflow:visible}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left svg{border-radius:100%;overflow:visible;width:18px;height:18px;padding:5px}.ba-backbutton.is-label .ba-common-button{height:32px;font-size:1rem}.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout{overflow:visible;line-height:1}.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left svg{width:24px;height:24px}.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__label{line-height:1.25rem;text-align:left}.ba-backbutton.is-nav_pane .ba-common-button{height:32px;width:32px}[dir=\"rtl\"] .ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left{margin-left:8px;margin-right:unset}[dir=\"rtl\"] .ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left{margin-left:8px;margin-right:unset}[dir=\"ltr\"] .ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left,.ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left{margin-right:8px;margin-left:unset}[dir=\"ltr\"] .ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left,.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__icon.is-left{margin-right:8px;margin-left:unset}[dir=\"rtl\"].ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left{margin-left:8px;margin-right:inherit}[dir=\"rtl\"].ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left{margin-left:8px;margin-right:inherit}[dir=\"rtl\"].ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__label{text-align:right}[dir=\"rtl\"].ba-backbutton svg{transform:rotate(180deg)}.ba-backbutton.is-nav_pane .ba-common-button{height:32px}.ba-backbutton.is-nav_pane .ba-common-button.is-variant_frameless{color:#595859}.ba-backbutton.is-nav_pane .ba-common-button.is-variant_frameless.is-hover:not(.is-disabled),.ba-backbutton.is-nav_pane .ba-common-button.is-variant_frameless:hover:not(.is-disabled):not(.is-tap){color:#0f62fe;color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1)}.ba-backbutton.is-nav_pane .ba-common-button.is-variant_frameless.is-active:not(.is-disabled),.ba-backbutton.is-nav_pane .ba-common-button.is-variant_frameless:active:not(.is-disabled):not(.is-tap){color:#0f62fe;color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);background-color:transparent}.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left svg{transition:color .2s ease-in-out;color:#0f62fe;color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1)}.ba-backbutton.is-label .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__label{color:#343334}.ba-backbutton.is-label .ba-common-button.is-variant_frameless.is-hover:not(.is-disabled) .ba-common-button__icon.is-left svg,.ba-backbutton.is-label .ba-common-button.is-variant_frameless:hover:not(.is-disabled):not(.is-tap) .ba-common-button__icon.is-left svg{color:#002d9c;color:hsla(var(--active-primary-h, 222.69231), var(--active-primary-s, 100%), var(--active-primary-l, 30.58824%), 1)}.ba-backbutton.is-label .ba-common-button.is-variant_frameless.is-active:not(.is-disabled),.ba-backbutton.is-label .ba-common-button.is-variant_frameless:active:not(.is-disabled):not(.is-tap){background-color:transparent}.ba-backbutton.is-label .ba-common-button.is-variant_frameless.is-active:not(.is-disabled) .ba-common-button__icon .ba-common-svgIcon,.ba-backbutton.is-label .ba-common-button.is-variant_frameless:active:not(.is-disabled):not(.is-tap) .ba-common-button__icon .ba-common-svgIcon{color:#002d9c;color:hsla(var(--active-primary-h, 222.69231), var(--active-primary-s, 100%), var(--active-primary-l, 30.58824%), 1)}.ba-backbutton.is-label .ba-common-button.is-disabled .ba-common-button__layout .ba-common-button__icon.is-left svg{color:#0f62fe;color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1)}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__icon.is-left svg{transition:color .2s ease-in-out,border-color .2s ease-in-out,background-color .2s ease-in-out;border:2px solid;color:#0f62fe;color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1)}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless .ba-common-button__layout .ba-common-button__label{font-size:1.5rem;line-height:2.1875rem;color:#343334}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless.is-hover:not(.is-disabled) .ba-common-button__icon.is-left svg,.ba-backbutton.is-standard .ba-common-button.is-variant_frameless:hover:not(.is-disabled):not(.is-tap) .ba-common-button__icon.is-left svg{background-color:#002d9c;background-color:hsla(var(--active-primary-h, 222.69231), var(--active-primary-s, 100%), var(--active-primary-l, 30.58824%), 1);border-color:#002d9c;border-color:hsla(var(--active-primary-h, 222.69231), var(--active-primary-s, 100%), var(--active-primary-l, 30.58824%), 1);color:#fff}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless.is-active:not(.is-disabled),.ba-backbutton.is-standard .ba-common-button.is-variant_frameless:active:not(.is-disabled):not(.is-tap){background-color:transparent}.ba-backbutton.is-standard .ba-common-button.is-variant_frameless.is-active:not(.is-disabled) .ba-common-button__icon.is-left svg,.ba-backbutton.is-standard .ba-common-button.is-variant_frameless:active:not(.is-disabled):not(.is-tap) .ba-common-button__icon.is-left svg{background-color:#002d9c;background-color:hsla(var(--active-primary-h, 222.69231), var(--active-primary-s, 100%), var(--active-primary-l, 30.58824%), 1);border-color:#002d9c;border-color:hsla(var(--active-primary-h, 222.69231), var(--active-primary-s, 100%), var(--active-primary-l, 30.58824%), 1);color:#fff}\n", ""]);

// exports
exports.locals = {
	"backButtonClassName": "\"ba-backbutton\""
};

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _BackButtonResources = _interopRequireDefault(__webpack_require__(152));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_BackButtonResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

var amdi18n={"__root":{"back":"Back"},"__cs":{"back":"Zpět"},"__da":{"back":"Tilbage"},"__de":{"back":"Zurück"},"__es":{"back":"Atrás"},"__fi":{"back":"Edellinen"},"__fr":{"back":"Précédent"},"__hr":{"back":"Natrag"},"__hu":{"back":"Vissza"},"__it":{"back":"Indietro"},"__ja":{"back":"戻る"},"__kk":{"back":"Артқа"},"__ko":{"back":"이전"},"__nb":{"back":"Tilbake"},"__nl":{"back":"Terug"},"__no":{"back":"Tilbake"},"__pl":{"back":"Wstecz"},"__pt":{"back":"Voltar"},"__pt-br":{"back":"Voltar"},"__ro":{"back":"Înapoi"},"__ru":{"back":"Назад"},"__sl":{"back":"Nazaj"},"__sv":{"back":"Föregående"},"__th":{"back":"ย้อนกลับ"},"__tr":{"back":"Geri"},"__zh":{"back":"后退"},"__zh-cn":{"back":"后退"},"__zh-hk":{"back":"上一步"},"__zh-mo":{"back":"上一步"},"__zh-sg":{"back":"后退"},"__zh-tw":{"back":"上一步"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/arrow--left_16");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[146,0]]]);
});